<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Deleted service accounts</h1>

                    <a v-sanitizedHref="`/#/admin/organizations/users/service-accounts/${tid}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-cog" aria-hidden="true"></i>
                        <span>Active service accounts</span>
                    </a>

                    <a v-sanitizedHref="`/#/admin/organizations/users/service-accounts/locked/${tid}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                        <span>Locked service accounts</span>
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <p class="text-muted">Deleted service accounts that have been disabled.</p>
            <UsersTable v-if="deletedServiceAccounts.length" :users="deletedServiceAccounts"></UsersTable>
            <h4 v-else>No deleted service accounts</h4>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, mixins } from 'vue-facing-decorator';
    import PageBase from "@common/PageBase";
    import VuePageQueries from "@Organizations/Users/queries-vue-component";
    import VuePageCommands from "@Organizations/Users/commands-vue-component";
    import "@common/AdminNavigationV2.vue";
    import "@Organizations/Users/Components/UsersTable.vue";

    @Component
    export default class DeletedServiceAccountsPage extends mixins(PageBase, VuePageQueries, VuePageCommands) {
        mounted() {
            this.setTitle("Deleted service accounts");
            // Include active=false, locked=false, deleted=true, includeServiceAccounts=true
            this.runSearchAllUsersQueryV1(this.tid, '', false, false, true, true);
        }

        get allUsersSearchResult() { return this.model?.AllUsersSearchResult; }
        get users() { return this.allUsersSearchResult?.Users || []; }
        get deletedServiceAccounts() { return this.users; }
    }
</script>

<style scoped>
</style>
